import { Plus } from "lucide-react";
import { Textarea } from "../../../components/ui/textarea";
import { Label } from "../../../components/ui/label";
import { useI18n } from "../../../i18n";
import { usePlans } from "../../../lib/plans";
import { PACKAGE_FEATURES } from "../../../components/PackageCards";
import { Group, Field, SaveBar, Toggle, RowTools, move, useDraft, useSectionSave } from "./shared";

export const PlansSection = () => {
  const { t } = useI18n();
  const { planName } = usePlans();
  const { settings, save, busy } = useSectionSave();
  const [plans, setPlans] = useDraft(settings.plans);
  const upd = (i, k, v) => setPlans(plans.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
  const add = () => setPlans([...plans, { key: `plan_${Date.now().toString(36)}`, name: "New plan", fee: 0, reward: 0, features: [], recommended: false, active: false }]);
  const submit = () => save({ plans: plans.map((p) => ({ ...p, fee: Number(p.fee) || 0, reward: Number(p.reward) || 0, features: p.features.map((f) => f.trim()).filter(Boolean) })) });
  return (
    <div className="space-y-6">
      <p className="text-sm text-muted-foreground">Inactive plans are hidden from the website and registration; members already on them keep their plan. A plan can only be deleted when no member uses it.</p>
      {plans.map((p, i) => (
        <Group key={p.key} title={p.name || planName(p.key)} desc={`Plan key: ${p.key}`}>
          <div className="flex justify-end"><RowTools onUp={() => setPlans(move(plans, i, -1))} onDown={() => setPlans(move(plans, i, 1))} onDelete={() => setPlans(plans.filter((_, j) => j !== i))} testId={`plan-${p.key}`} /></div>
          <div className="grid gap-4 md:grid-cols-3">
            <Field label="Display name" value={p.name} placeholder={planName(p.key)} onChange={(v) => upd(i, "name", v)} testId={`plan-${p.key}-name-input`} />
            <Field label="Registration fee (ETB)" type="number" min={0} value={p.fee} onChange={(v) => upd(i, "fee", v)} testId={`plan-${p.key}-fee-input`} />
            <Field label="Reward / support amount (ETB)" type="number" min={0} value={p.reward} onChange={(v) => upd(i, "reward", v)} testId={`plan-${p.key}-reward-input`} />
          </div>
          <div className="space-y-1.5">
            <Label>Benefits (one per line — leave empty for the translated defaults)</Label>
            <Textarea rows={4} value={p.features.join("\n")} placeholder={(PACKAGE_FEATURES[p.key] || []).map((k) => t(k)).join("\n")} onChange={(e) => upd(i, "features", e.target.value.split("\n"))} data-testid={`plan-${p.key}-features-input`} />
          </div>
          <div className="grid gap-3 md:grid-cols-2">
            <Toggle label="Active (open for registration)" checked={p.active} onChange={(v) => upd(i, "active", v)} testId={`plan-${p.key}-active`} />
            <Toggle label="Highlight as recommended" checked={p.recommended} onChange={(v) => upd(i, "recommended", v)} testId={`plan-${p.key}-recommended`} />
          </div>
        </Group>
      ))}
      <div className="flex flex-wrap gap-3">
        <button type="button" onClick={add} className="btn-ghost-gold" data-testid="plan-add-btn"><Plus className="h-4 w-4" />Add plan</button>
        <SaveBar onClick={submit} busy={busy} testId="plans-save-btn" />
      </div>
    </div>
  );
};
